import { BaseModel } from "../../utils/base-models/base-model";

export class Coach extends BaseModel {
    public coachID: string | null | undefined;
    public description: string | null | undefined;
    public introduction: string | null | undefined;
    public achievement: string | null | undefined;
    
    public userCode: string | null | undefined;
    public userName: string | null | undefined;
    public avatarUser: string | null | undefined;
    public fullName: string | null | undefined;
    public nickName: string | null | undefined;
    public point: number | null | undefined;
    public doublePoint: number | null | undefined;
    public static typeName = 'Coach';
    constructor(init?: Partial<Coach>) {
        super(Coach.typeName);
        Object.assign(this, init)
    }
}

export class CoachReview extends BaseModel {
    public coachID: string | null | undefined;
    public coachReviewID: string | null | undefined;
    public introduction: string | null | undefined;
    public achievement: string | null | undefined;
    
    public userCode: string | null | undefined;
    public userName: string | null | undefined;
    public avatarUser: string | null | undefined;
    public fullName: string | null | undefined;
    public nickName: string | null | undefined;
    public point: number | null | undefined;
    public doublePoint: number | null | undefined;
    public static typeName = 'CoachReview';
    constructor(init?: Partial<CoachReview>) {
        super(CoachReview.typeName);
        Object.assign(this, init)
    }
}